function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ai from "./client-hints-parser.js";
import gi from "./user-agent-parser.js";
import { Browsers as oi, OperatingSystems as so } from "./device-constants.js";

var ui = /*#__PURE__*/function () {
  function ui() {
    var _this = this;

    _classCallCheck(this, ui);

    var t = navigator.userAgentData ? ai : gi;
    this.Sg = new t(), this.userAgent = navigator.userAgent, this.browser = this.Sg.ef(), this.version = this.Sg.ff(), this.OS = null, this.ec().then(function (t) {
      return _this.OS = t;
    });
    var i = navigator;
    this.language = (i.userLanguage || i.language || i.browserLanguage || i.systemLanguage || "").toLowerCase(), this.Ja = ui.vg(this.userAgent);
  }

  _createClass(ui, [{
    key: "fE",
    value: function fE() {
      return this.browser === oi.Bg;
    }
  }, {
    key: "ic",
    value: function ic() {
      return this.OS || null;
    }
  }, {
    key: "ec",
    value: function ec() {
      var _this2 = this;

      return this.OS ? Promise.resolve(this.OS) : this.Sg.ec(ui.kg).then(function (t) {
        return _this2.OS = t, t;
      });
    }
  }], [{
    key: "vg",
    value: function vg(t) {
      t = t.toLowerCase();
      var i = ["googlebot", "bingbot", "slurp", "duckduckbot", "baiduspider", "yandex", "facebookexternalhit", "sogou", "ia_archiver", "https://github.com/prerender/prerender", "aolbuild", "bingpreview", "msnbot", "adsbot", "mediapartners-google", "teoma", "taiko"];

      for (var n = 0; n < i.length; n++) {
        if (-1 !== t.indexOf(i[n])) return !0;
      }

      return !1;
    }
  }]);

  return ui;
}();

ui.kg = [{
  string: navigator.platform,
  cf: "Win",
  identity: so.Og
}, {
  string: navigator.platform,
  cf: "Mac",
  identity: so.Pg
}, {
  string: navigator.platform,
  cf: "BlackBerry",
  identity: "BlackBerry"
}, {
  string: navigator.platform,
  cf: "FreeBSD",
  identity: "FreeBSD"
}, {
  string: navigator.platform,
  cf: "OpenBSD",
  identity: "OpenBSD"
}, {
  string: navigator.platform,
  cf: "Nintendo",
  identity: "Nintendo"
}, {
  string: navigator.platform,
  cf: "SunOS",
  identity: "SunOS"
}, {
  string: navigator.platform,
  cf: "PlayStation",
  identity: "PlayStation"
}, {
  string: navigator.platform,
  cf: "X11",
  identity: "X11"
}, {
  string: navigator.userAgent,
  cf: ["iPhone", "iPad", "iPod"],
  identity: so.ao
}, {
  string: navigator.platform,
  cf: "Pike v",
  identity: so.ao
}, {
  string: navigator.userAgent,
  cf: ["Web0S"],
  identity: "WebOS"
}, {
  string: navigator.userAgent,
  cf: "Tizen",
  identity: "Tizen"
}, {
  string: navigator.platform,
  cf: ["Linux armv7l", "Android"],
  identity: so.xg
}, {
  string: navigator.userAgent,
  cf: ["Android"],
  identity: so.xg
}, {
  string: navigator.platform,
  cf: "Linux",
  identity: "Linux"
}];
var ro = new ui();
export { ro as default, ui as BrowserDetector };